// Countdown & ETA utilities for booking lifecycle

/**
 * Parse ETA text like "15 minutes", "30 minutes", "45 minutes" to integer minutes
 */
export const parseEtaMinutes = (etaText) => {
  if (!etaText) return null;
  const match = etaText.match(/(\d+)/);
  return match ? parseInt(match[1], 10) : null;
};

/**
 * Calculate seconds remaining until a target timestamp.
 * Returns negative values if already expired.
 */
export const getTimeRemaining = (expiresAt) => {
  if (!expiresAt) return null;
  const diff = new Date(expiresAt).getTime() - Date.now();
  return Math.floor(diff / 1000);
};

/**
 * Format seconds into a readable countdown string.
 * e.g. 1805 => "30:05", 65 => "1:05", 5 => "0:05"
 */
export const formatCountdown = (totalSeconds) => {
  if (totalSeconds == null || totalSeconds < 0) return '0:00';
  const mins = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

/**
 * Check if the no-show threshold has been exceeded.
 * Threshold = accepted_at + ETA minutes + 20 min buffer.
 * Returns { exceeded: boolean, minutesOverdue: number }
 */
export const checkNoShowThreshold = (acceptedAt, estimatedArrival) => {
  if (!acceptedAt || !estimatedArrival) return { exceeded: false, minutesOverdue: 0 };

  const etaMinutes = parseEtaMinutes(estimatedArrival);
  if (etaMinutes == null) return { exceeded: false, minutesOverdue: 0 };

  const thresholdMs = new Date(acceptedAt).getTime() + (etaMinutes + 20) * 60 * 1000;
  const overdueMs = Date.now() - thresholdMs;

  return {
    exceeded: overdueMs > 0,
    minutesOverdue: Math.max(0, Math.floor(overdueMs / 60000))
  };
};
